/* global axios */
import ApiClient from './ApiClient';

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }

  getByConversation(conversationId) {
    return axios.get(`${this.url}?conversation_id=${conversationId}`);
  }

  getByContact(contactId) {
    return axios.get(`${this.url}?contact_id=${contactId}`);
  }

  // Só o que o agente logado agendou, em qualquer conversa.
  getMine() {
    return axios.get(`${this.url}?mine=true`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }
}

export default new ScheduledMessagesAPI();
